import { createStore } from 'redux';
import rootReducer from './reducer'; // Your root reducer

const store = createStore(rootReducer);

export default store;